export default {
  noDashboards: 'Brak dostępnych pulpitów nawigacyjnych dla {asset}.',
  noWidgets: 'Brak dostępnych widżetów dla {dashboard}.',
  addDashboard: 'Utwórz pulpit nawigacyjny',
  addWidget: 'Dodaj widget',
};
